<template>
  <div class="review-import">
    <div class="review-import__title">Review Import</div>
        <div>
            <div class="review-import" :class="`status-${alert.status}`" v-for="(alert, i) in review.alerts" :key="i">
                <span>{{ alert.text }}</span>
            </div>
        </div>
        <div>
            <ol>
                <li v-for="(item, i) in review.data" :key=i>
                    {{ item }}
                </li>
            </ol>
        </div>
    <div class="review-import__controls">
      <button class="review-import__button review-import__button_cancel"
              @click.prevent="close()">Cancel
      </button>
      <button class="review-import__button review-import__button_submit"
              @click.prevent="apply()">
        Re-Upload
      </button>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}
export default {
  name: 'ReviewImportPopup',
  mixins: [BaseModalMixins],
  props: {
    review: {
      type: Object
    }
  },
  data () {
    return {
      pivot_table: -1,
      file: null,
      externalErrors: {
        pivot_table: null,
        file: null
      },
      selectTypeStyle: { ...SELECT_STYLE }
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    showErrors (errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    apply () {
      this.$emit('apply')
    },
    fileChange (file) {
      this.file = file
    }
  }
}
</script>

<style lang="scss">
  .review-import {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }
  }

  .status-error {
      background-color: $rfx-light-red;
      border-radius: 10px;
      width: 70%;
      margin: auto;
  }

  .status-success {
      background-color: $rfx-light-green;
      border-radius: 10px;
      width: 70%;
      margin: auto;
  }

  .status-processing {
      background-color: $rfx-light-lilac;
      border-radius: 10px;
      width: 70%;
      margin: auto;
  }

</style>
